import React from "react";
import styles from "./GruntListSkeleton.module.scss";

export const GruntListSkeleton: React.FC = () => {
  return (
    <div className={styles.container}>
      <div className={styles.titleSkeleton} />
      <div className={styles.items}>
        {Array.from({ length: 2 }).map((_, i) => (
          <div key={i} className={styles.card}>
            <div className={styles.headerSkeleton} />
            <div className={styles.row}>
              <div className={styles.labelSkeleton} />
              <div className={styles.valueSkeleton} />
            </div>
            <div className={styles.row}>
              <div className={styles.labelSkeleton} />
              <div className={styles.valueSkeleton} />
            </div>
            <div className={styles.buttonSkeleton} />
          </div>
        ))}
      </div>
    </div>
  );
};
